import {Record, Map} from "immutable"
import {Users, JsonData as UserJsonData, fromJs as userFromJs} from "./User"
import {Companies, JsonData as CompanyJsonData, fromJs as companyFromJs} from "./Company"

interface Properties {
    id: number
    title: string
    exported: boolean
    printed: boolean
    result: boolean
    users?: Users
    companies?: Companies
    divisions?: Divisions
}

export class Division extends Record({
    id: undefined,
    title: undefined,
    exported: undefined,
    printed: undefined,
    result: undefined,
    users: Map(),
    companies: Map(),
    divisions: Map(),
}) implements Properties {
    id: number
    title: string
    exported: boolean
    printed: boolean
    result: boolean
    users: Users
    companies: Companies
    divisions: Divisions

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    title: string
    exported: boolean
    printed: boolean
    result: boolean
    users?: UserJsonData[]
    companies?: CompanyJsonData[]
    divisions?: JsonData[]
}

export const fromJs = ({
    id,
    title,
    exported,
    printed,
    result,
    users,
    companies,
    divisions,
}: JsonData): Division => {
    let data: Properties = {
        id,
        title,
        exported,
        printed,
        result,
    }

    if (users) {
        data.users = <Users>Map(users.map(user => [user.id, userFromJs(user)]))
    }

    if (companies) {
        data.companies = <Companies>Map(companies.map(company => [company.id, companyFromJs(company)]))
    }

    if (divisions) {
        data.divisions = <Divisions>Map(divisions.map(division => [division.id, fromJs(division)]))
    }

    return new Division(data)
}

export type Divisions = Map<number, Division>